import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, isRef as _isRef, withModifiers as _withModifiers, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/back2.png';
const _withScopeId = n => (_pushScopeId("data-v-891b34f6"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "page-box",
  style: {
    "position": "relative"
  }
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1));
const _hoisted_3 = [_hoisted_2];
import { ElMessage } from 'element-plus';
import { useRoute, useRouter } from 'vue-router';
import { useCommon } from '@/common/hooks/useCommon';
import { useLayoutStore, useStaticDictStore } from '@/store';
import { useDownload } from '@/common/hooks/useDownload';
import { useDropdown } from '@/common/hooks/useDropdown';
import { useUpload } from '@/common/hooks/useUpload';
import { useUploadWidget } from '@/common/hooks/useUploadWidget';
import { DictionaryController } from '@/api/system';
import { WckWeekPlanController } from "@/api/generated";

import { ref, reactive, getCurrentInstance, computed, onMounted } from 'vue';
// 表单数据
const __default__ = {
  name: 'wkcWeeklySchedule'
};
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    id: {
      default: undefined
    },
    subPage: {
      type: [Number, String, Boolean],
      default: 0
    },
    saveOnSubmit: {
      type: Boolean,
      default: true
    },
    rowData: {
      default: undefined
    }
  },
  setup(__props) {
    const router = useRouter();
    const route = useRoute();
    const layoutStore = useLayoutStore();
    const {
      downloadFile
    } = useDownload();
    const {
      getUploadHeaders,
      getUploadActionUrl,
      fileListToJson,
      parseUploadData,
      getPictureList
    } = useUpload();
    const {
      Delete,
      Search,
      Edit,
      Plus,
      Refresh,
      Picture,
      Dialog,
      mainContextHeight,
      clientHeight,
      checkPermCodeExist,
      parseParams,
      parseArrayParams,
      formatDateByStatsType,
      getDateRangeFilter
    } = useCommon();
    // 静态字典
    const {
      staticDict: StaticDict
    } = useStaticDictStore();
    const props = __props;
    const wkcWeeklyScheduleRef = ref();
    // 表单数据定义
    const formData = reactive({
      WeeklySchedule: {
        // 主键id
        id: undefined,
        // 更新用户id
        updateUserId: undefined,
        // 创建用户id
        createUserId: undefined,
        // 更新时间
        updateTime: undefined,
        // 创建时间
        createTime: undefined,
        // 日程内容
        content: undefined,
        // 开始日期
        date: undefined,
        // 开始时间
        startTime: undefined,
        // 结束时间
        endTime: undefined,
        // 日程状态(pending:待定，in-progress:进行中，completed:完成)
        status: undefined,
        // 附件
        fileUrl: undefined,
        // 组织id
        orgId: undefined,
        // 租户id
        ecId: undefined,
        // 部门Id
        deptId: undefined,
        // 岗位Id
        postId: undefined,
        // 是否删除状态，1删除, 0正常
        deleteStatus: undefined,
        // 位置地点
        locations: undefined,
        // 抄送人员id
        ccPerson: undefined,
        filesManage: {
          // 主键
          fId: undefined,
          // 附件名称
          attachmentName: undefined,
          // 上传时间
          uploadTime: undefined,
          // 附件url
          attachmentUrl: undefined,
          // 附件类型
          attachmentType: undefined,
          // 创建时间
          createdTime: undefined,
          // 创建人id
          createdUserId: undefined,
          // 更新时间
          updatedTime: undefined,
          // 更新人id
          updatedUserId: undefined,
          // 业务id
          bizId: undefined,
          // 业务类型
          bizType: undefined
        }
      }
    });
    // 表单验证规则
    const rules = reactive({
      'WeeklySchedule.locations': [],
      'WeeklySchedule.fileUrl': [],
      'WeeklySchedule.content': [],
      'WeeklySchedule.ccPerson': [],
      'WeeklySchedule.startTime': [],
      'WeeklySchedule.date': [],
      'WeeklySchedule.endTime': []
    });
    const instance = getCurrentInstance();
    const onCancel = () => {
      router.go(-1);
      layoutStore.removeCachePage(route.fullPath);
      route.meta.refreshParentCachedPage = true;
    };
    const isEdit = computed(() => {
      return props.saveOnSubmit ? props.id != null : props.rowData != null;
    });
    // 初始化页面数据
    console.log('init page data');
    const loadWeeklyScheduleData = () => {
      return new Promise((resolve, reject) => {
        console.log('init page data222');
        let params = {
          id: props.id
        };
        WckWeekPlanController.viewById(params).then(res => {
          formData.WeeklySchedule = {
            ...res.data
          };
          if (typeof res.data.ccPerson === 'string') {
            formData.WeeklySchedule.ccPerson = res.data.ccPerson.replace(/"/g, '').split(',');
          } else {
            formData.WeeklySchedule.ccPerson = [];
          }
          let attachmentUrlDownloadParams = {
            fId: res.data.id,
            fieldName: 'attachmentUrl',
            asImage: false
          };
          fileUrlWidgetFileList.value = parseUploadData(res.data.fileUrl, attachmentUrlDownloadParams);
          resolve();
        }).catch(e => {
          reject(e);
        });
      });
    };
    /**
     * 参与人员下拉数据获取函数
     */
    const loadCcPersonDropdownList = () => {
      return new Promise((resolve, reject) => {
        const params = {};
        DictionaryController.dictSysUser(params).then(res => {
          resolve({
            dataList: res.getList()
          });
        }).catch(e => {
          reject(e);
        });
      });
    };
    // 参与人员配置参数
    const ccPersonOptions = {
      loadData: loadCcPersonDropdownList,
      isTree: false
    };
    // 参与人员下拉组件
    const ccPersonWidget = useDropdown(ccPersonOptions);
    const {
      dropdownList: ccPersonWidgetDropdownList
    } = ccPersonWidget;
    /**
     * 附件上传文件改变
     */
    const onFileUrlChange = val => {
      formData.WeeklySchedule.fileUrl = fileListToJson(val);
    };
    // 附件上传文件组件
    const fileUrlWidget = useUploadWidget(30);
    const {
      fileList: fileUrlWidgetFileList,
      maxCount: fileUrlWidgetMaxCount
    } = fileUrlWidget;
    const onUploadError = () => {
      ElMessage.error('文件上传失败');
    };
    const onUploadLimit = () => {
      ElMessage.error('已经超出最大上传个数限制');
    };
    const refreshWkcWeeklySchedule = () => {
      // 刷新段落
    };
    /**
     * 重置过滤值
     */
    const resetWkcWeeklySchedule = () => {
      refreshWkcWeeklySchedule();
    };
    /**
     * 重置所有过滤值
     */
    const resetFilter = () => {
      resetWkcWeeklySchedule();
    };
    const formInit = () => {
      loadWeeklyScheduleData().then(res => {
        ccPersonWidget.onVisibleChange(true).catch(e => {
          console.error(e);
        });
        if (isEdit.value) refreshWkcWeeklySchedule();
      }).catch(e => {
        // TODO: 异常处理
        console.error(e);
      });
    };
    onMounted(() => {
      formInit();
    });
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_date_picker = _resolveComponent("el-date-picker");
      const _component_custom_upload = _resolveComponent("custom-upload");
      const _component_upload_file_list = _resolveComponent("upload-file-list");
      const _component_el_row = _resolveComponent("el-row");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_scrollbar = _resolveComponent("el-scrollbar");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_scrollbar, {
        class: "custom-scroll content-box"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form, {
          ref_key: "wkcWeeklyScheduleRef",
          ref: wkcWeeklyScheduleRef,
          model: _unref(formData),
          size: _unref(layoutStore).defaultFormItemSize,
          rules: _unref(rules),
          "label-width": "120px",
          "label-position": "right",
          onSubmit: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["prevent"]))
        }, {
          default: _withCtx(() => [_createVNode(_component_el_row, {
            gutter: 16,
            style: {
              "background": "white",
              "padding": "16px"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "日程内容",
                prop: "WeeklySchedule.content"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  class: "input-item",
                  modelValue: _unref(formData).WeeklySchedule.content,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(formData).WeeklySchedule.content = $event),
                  type: "textarea",
                  placeholder: "",
                  clearable: true,
                  "show-word-limit": false,
                  maxlength: "",
                  readonly: true
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "位置地点",
                prop: "WeeklySchedule.locations"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  class: "input-item",
                  modelValue: _unref(formData).WeeklySchedule.locations,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _unref(formData).WeeklySchedule.locations = $event),
                  type: "textarea",
                  placeholder: "",
                  clearable: true,
                  "show-word-limit": false,
                  maxlength: "",
                  readonly: true
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "参与人员",
                prop: "WeeklySchedule.ccPerson"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  class: "input-item",
                  modelValue: _unref(formData).WeeklySchedule.ccPerson,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _unref(formData).WeeklySchedule.ccPerson = $event),
                  placeholder: "",
                  clearable: true,
                  filterable: true,
                  disabled: true,
                  onVisibleChange: _unref(ccPersonWidget).onVisibleChange,
                  multiple: ""
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ccPersonWidgetDropdownList), item => {
                    return _openBlock(), _createBlock(_component_el_option, {
                      key: item.id,
                      label: item.name,
                      value: item.id
                    }, null, 8, ["label", "value"]);
                  }), 128))]),
                  _: 1
                }, 8, ["modelValue", "onVisibleChange"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "开始日期",
                prop: "WeeklySchedule.date"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_date_picker, {
                  class: "input-item",
                  modelValue: _unref(formData).WeeklySchedule.date,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _unref(formData).WeeklySchedule.date = $event),
                  type: "date",
                  placeholder: "",
                  clearable: true,
                  format: "YYYY-MM-DD",
                  "value-format": "YYYY-MM-DD",
                  disabled: true
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "开始时间",
                prop: "WeeklySchedule.startTime"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_date_picker, {
                  class: "input-item",
                  modelValue: _unref(formData).WeeklySchedule.startTime,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _unref(formData).WeeklySchedule.startTime = $event),
                  type: "datetime",
                  placeholder: "",
                  clearable: true,
                  format: "HH:mm:ss",
                  "value-format": "HH:mm:ss",
                  disabled: true
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "结束时间",
                prop: "WeeklySchedule.endTime"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_date_picker, {
                  class: "input-item",
                  modelValue: _unref(formData).WeeklySchedule.endTime,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _unref(formData).WeeklySchedule.endTime = $event),
                  type: "datetime",
                  placeholder: "",
                  clearable: true,
                  format: "HH:mm:ss",
                  "value-format": "HH:mm:ss",
                  disabled: true
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "附件",
                prop: "WeeklySchedule.fileUrl"
              }, {
                default: _withCtx(() => [_createVNode(_component_custom_upload, {
                  modelValue: _unref(fileUrlWidgetFileList),
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => _isRef(fileUrlWidgetFileList) ? fileUrlWidgetFileList.value = $event : null),
                  name: "uploadFile",
                  size: _unref(layoutStore).defaultFormItemSize,
                  type: "dropdown",
                  headers: _unref(getUploadHeaders),
                  action: _unref(getUploadActionUrl)('/admin/app/filesManage/upload'),
                  data: {
                    fieldName: 'attachmentUrl',
                    asImage: false
                  },
                  limit: _unref(fileUrlWidgetMaxCount),
                  onChange: onFileUrlChange,
                  disabled: true
                }, null, 8, ["modelValue", "size", "headers", "action", "limit"]), _createVNode(_component_upload_file_list, {
                  "file-list": _unref(fileUrlWidgetFileList),
                  type: "card",
                  direction: "horizontal",
                  readonly: true
                }, null, 8, ["file-list"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }, 8, ["model", "size", "rules"])]),
        _: 1
      }), _createVNode(_component_el_row, {
        class: "menu-box",
        type: "flex",
        justify: "end",
        align: "middle"
      }), _ctx.subPage ? (_openBlock(), _createElementBlock("label", {
        key: 0,
        class: "page-close-box",
        onClick: _cache[8] || (_cache[8] = $event => onCancel())
      }, _hoisted_3)) : _createCommentVNode("", true)]);
    };
  }
});